export const computeMaxPackage = (child) => {
  if (child.wisProduct.warehouseInventory <= 0) return 0;

  return Math.floor(child.wisProduct.warehouseInventory / child.qty);
};
